var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: _vm.calculatorUrl, method: "post" },
      on: { submit: _vm.onSubmit },
    },
    [
      _c("exercisemodal", {
        ref: "exerciseSelectorModal",
        attrs: { "static-url": _vm.staticUrl, standard: true },
        on: { "on-select": _vm.selectExercise },
      }),
      _vm._v(" "),
      _c("howtomodal", {
        ref: "howToModal",
        attrs: { "static-url": _vm.staticUrl },
        model: {
          value: _vm.howToExerciseId,
          callback: function ($$v) {
            _vm.howToExerciseId = $$v
          },
          expression: "howToExerciseId",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }, [
          _c("label", { staticClass: "label", attrs: { for: "gender" } }, [
            _vm._v(_vm._s(_vm.$t("forms.percentile.gender"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control is-expanded" }, [
              _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.liftViewModel.gender,
                        expression: "liftViewModel.gender",
                      },
                    ],
                    attrs: { id: "gender", name: "gender" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.liftViewModel,
                          "gender",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "male" } }, [
                      _vm._v(_vm._s(_vm.$t("enums.gender.male"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "female" } }, [
                      _vm._v(_vm._s(_vm.$t("enums.gender.female"))),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }, [
          _c("label", { staticClass: "label", attrs: { for: "ageyears" } }, [
            _vm._v(_vm._s(_vm.$t("forms.percentile.age"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field has-addons" }, [
            _c("div", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.liftViewModel.ageyears,
                    expression: "liftViewModel.ageyears",
                  },
                ],
                staticClass: "input",
                attrs: {
                  name: "ageyears",
                  id: "ageyears",
                  type: "number",
                  min: "5",
                  max: "120",
                  required: "",
                },
                domProps: { value: _vm.liftViewModel.ageyears },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.liftViewModel, "ageyears", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("span", { staticClass: "button is-static" }, [
                _vm._v(_vm._s(_vm.$t("forms.percentile.yearsold"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }, [
          _c("label", { staticClass: "label", attrs: { for: "bodymass" } }, [
            _vm._v(_vm._s(_vm.$t("forms.percentile.bodyweight"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c(
            "div",
            { staticClass: "field has-addons" },
            [
              _c("div", { staticClass: "control is-expanded" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.liftViewModel.bodymass,
                      expression: "liftViewModel.bodymass",
                    },
                  ],
                  staticClass: "input",
                  attrs: {
                    type: "number",
                    id: "bodymass",
                    name: "bodymass",
                    required: "",
                    min: "5",
                    max: "400",
                    step: _vm.bodyMassUnit.step,
                  },
                  domProps: { value: _vm.liftViewModel.bodymass },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.liftViewModel,
                        "bodymass",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.liftViewModel.bodymassunit,
                          expression: "liftViewModel.bodymassunit",
                        },
                      ],
                      attrs: { name: "bodymassunit" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.liftViewModel,
                            "bodymassunit",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.bodyMassUnits, function (bodyMassUnit) {
                      return _c(
                        "option",
                        { domProps: { value: bodyMassUnit } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(bodyMassUnit) +
                              "\n              "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.bodyMassUnit.remainderSymbol
                ? [
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.liftViewModel.bodymass_minor,
                            expression: "liftViewModel.bodymass_minor",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "number",
                          name: "bodymass_minor",
                          min: "0",
                          step: _vm.bodyMassUnit.step,
                          max:
                            _vm.bodyMassUnit.remainderMultiple -
                            _vm.bodyMassUnit.step,
                          disabled: !_vm.bodyMassUnit.remainderSymbol,
                          required: !!_vm.bodyMassUnit.remainderSymbol,
                        },
                        domProps: { value: _vm.liftViewModel.bodymass_minor },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.liftViewModel,
                              "bodymass_minor",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c("span", { staticClass: "button is-static" }, [
                        _vm._v(_vm._s(_vm.bodyMassUnit.remainderSymbol)),
                      ]),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }, [
          _c(
            "label",
            {
              staticClass: "label",
              attrs: { for: "exercise" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showExerciseSelector.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("forms.percentile.exercise")))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              { staticClass: "control control--modal has-icons-right" },
              [
                _c("input", {
                  attrs: { type: "hidden", name: "exercise" },
                  domProps: { value: _vm.liftViewModel.exercise },
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "input",
                  attrs: { id: "exercise", type: "text", autocomplete: "off" },
                  domProps: { value: _vm.exercise.name },
                  on: { click: _vm.showExerciseSelector },
                }),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label" }),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "a",
                {
                  staticClass: "button is-small",
                  attrs: {
                    href: _vm.getStandardsUrl(_vm.exercise),
                    title: _vm.getStandardsTitle(_vm.exercise.name),
                  },
                  on: { click: _vm.onStandardsClick },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("forms.percentile.standards"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button is-small",
                  on: { click: _vm.openHowTo },
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("forms.percentile.howto"))),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.exercise.category === "Bodyweight"
        ? [
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c(
                  "label",
                  { staticClass: "label", attrs: { for: "variation" } },
                  [_vm._v(_vm._s(_vm.$t("forms.percentile.variation")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select is-fullwidth" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.liftViewModel.variation,
                              expression: "liftViewModel.variation",
                            },
                          ],
                          attrs: { name: "variation", id: "variation" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.liftViewModel,
                                "variation",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "bodyweight" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("enums.variation.bodyweight"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "weighted" } }, [
                            _vm._v(_vm._s(_vm.$t("enums.variation.weighted"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "assisted" } }, [
                            _vm._v(_vm._s(_vm.$t("enums.variation.assisted"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.liftViewModel.variation === "assisted"
              ? _c("div", { staticClass: "field is-horizontal" }, [
                  _c("div", { staticClass: "field-label is-normal" }, [
                    _c(
                      "label",
                      {
                        staticClass: "label",
                        attrs: { for: "assistancemass" },
                      },
                      [_vm._v(_vm._s(_vm.$t("forms.percentile.assistance")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c("div", { staticClass: "control is-expanded" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.liftViewModel.assistancemass,
                              expression: "liftViewModel.assistancemass",
                            },
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "number",
                            id: "assistancemass",
                            name: "assistancemass",
                            min: "1",
                            max: "800",
                            required: "",
                            step: _vm.liftMassUnit.step,
                          },
                          domProps: { value: _vm.liftViewModel.assistancemass },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.liftViewModel,
                                "assistancemass",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c("div", { staticClass: "select" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.liftViewModel.liftmassunit,
                                  expression: "liftViewModel.liftmassunit",
                                },
                              ],
                              attrs: { name: "liftmassunit" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.liftViewModel,
                                    "liftmassunit",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.liftMassUnits, function (liftMassUnit) {
                              return _c(
                                "option",
                                { domProps: { value: liftMassUnit } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(liftMassUnit) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.liftViewModel.variation === "weighted"
              ? _c("div", { staticClass: "field is-horizontal" }, [
                  _c("div", { staticClass: "field-label is-normal" }, [
                    _c(
                      "label",
                      { staticClass: "label", attrs: { for: "extramass" } },
                      [_vm._v(_vm._s(_vm.$t("forms.percentile.extraweight")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c("div", { staticClass: "control is-expanded" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.liftViewModel.extramass,
                              expression: "liftViewModel.extramass",
                            },
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "number",
                            id: "extramass",
                            name: "extramass",
                            min: "1",
                            max: "800",
                            required: "",
                            step: _vm.liftMassUnit.step,
                          },
                          domProps: { value: _vm.liftViewModel.extramass },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.liftViewModel,
                                "extramass",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c("div", { staticClass: "select" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.liftViewModel.liftmassunit,
                                  expression: "liftViewModel.liftmassunit",
                                },
                              ],
                              attrs: { name: "liftmassunit" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.liftViewModel,
                                    "liftmassunit",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.liftMassUnits, function (liftMassUnit) {
                              return _c(
                                "option",
                                { domProps: { value: liftMassUnit } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(liftMassUnit) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        : _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-label is-normal" }, [
              _c(
                "label",
                { staticClass: "label", attrs: { for: "liftmass" } },
                [_vm._v("\n        " + _vm._s(_vm.weightLabel) + "\n      ")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field is-expanded" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.liftViewModel.liftmass,
                          expression: "liftViewModel.liftmass",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "number",
                        id: "liftmass",
                        name: "liftmass",
                        min: "1",
                        max: "1500",
                        required: "",
                        step: _vm.liftMassUnit.step,
                      },
                      domProps: { value: _vm.liftViewModel.liftmass },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.liftViewModel,
                            "liftmass",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.liftViewModel.liftmassunit,
                              expression: "liftViewModel.liftmassunit",
                            },
                          ],
                          attrs: { name: "liftmassunit" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.liftViewModel,
                                "liftmassunit",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.liftMassUnits, function (liftMassUnit) {
                          return _c(
                            "option",
                            { domProps: { value: liftMassUnit } },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(liftMassUnit) +
                                  "\n                "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.weightHelp
                  ? _c("p", { staticClass: "help" }, [
                      _vm._v(_vm._s(_vm.weightHelp)),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }, [
          _c("label", { staticClass: "label", attrs: { for: "repetitions" } }, [
            _vm._v(_vm._s(_vm.$t("forms.percentile.repetitions"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.liftViewModel.repetitions,
                    expression: "liftViewModel.repetitions",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "number",
                  name: "repetitions",
                  id: "repetitions",
                  min: "1",
                  max: "500",
                },
                domProps: { value: _vm.liftViewModel.repetitions },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.liftViewModel,
                      "repetitions",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }),
        _vm._v(" "),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary is-medium",
                  attrs: { type: "submit" },
                },
                [_vm._v(_vm._s(_vm.$t("forms.percentile.calculatestrength")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.timezone,
                    expression: "timezone",
                  },
                ],
                attrs: { type: "hidden", name: "timezone" },
                domProps: { value: _vm.timezone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.timezone = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "source", value: "homepage" },
              }),
            ]),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "slicon slicon-fa-table",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "slicon slicon-fa-graduation-cap" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }